import React, { useEffect, useState } from 'react';
import { connect, useStore } from "react-redux";
import useMedia from 'use-media';
import CommonUtil from "../../common/commonUtil";
import { TextArea } from '../../components/atoms/textArea';
import { getCourseInfo, getYoyakuKanoTimeInfo } from '../../const';
import messageConst from '../../const/messageConst';
import common from '../../resources/js/common/common';
import { Label } from '../atoms/label';
import { CheckboxListBoxGold } from './checkboxListBoxGold';
import { LabelInputForm } from './labelInputForm';
import { ModalOptionForm } from './modalOptionForm';
import { PullDownOptionForm } from './pullDownOptionForm';
import { RadioButtonForm } from './radioButtonForm';
import { RoomQrReader } from './roomQrReader';

export const EstheticInputList = (props) => {
    const { state,
        flgList,
        estheticInfo,
        agreementList,
        onChangeAgreement,
        relationList,
        serviceCheckInfo,
        estheRsvInfo,
        handleRepresentInfo,
        onChangeRelation,
        onChangeCheckBox,
        onClickServiceLink,
        onClickDoiTitle,
        onClickOpenPopupWindow,
        onClickOpenCalendarWindow,
        responsiveFlg,
        confirmFlg,
        setPopupData,
        loginFlg
    } = props;

    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });

    const hopeCheckboxData = [
        { value: "希望する", id: true },
    ];
    const otherMailCheckbox = [
        { value: "上記アドレス以外に送付", id: true },
    ];
    const agreement = [
        { value: "同意する", id: "1" }
    ]

    const store = useStore();
    const isCrawl = store.getState().login.loginType === 'CRAWL';
    const crawlMember = store.getState().crawlMember;

    // モーダルオープン
    const openCal = (e) => {
        if (e != undefined) {
            if (e.target.id === 'reserveDate') {
                let riyoDate = estheRsvInfo.riyoDate ? CommonUtil.getDateFromString(estheRsvInfo.riyoDate, "-") : new Date();
                let startDate = new Date(riyoDate);
                startDate.setDate(1);
                startDate.setDate(startDate.getDate() - startDate.getDay());
                let baseDate = new Date();
                baseDate.setDate(baseDate.getDate())
                if ((baseDate.getFullYear() === riyoDate.getFullYear() && baseDate.getMonth() === riyoDate.getMonth()) || baseDate >= startDate) {
                    startDate = new Date(baseDate);
                }
                const reqStartDate = CommonUtil.getStringFromDate(startDate,"yyyy-MM-dd");

                onClickOpenCalendarWindow(reqStartDate);
            }
        }
    }

    // 予約時間一覧取得後処理
    const afterGetYoyakuKanoTimeInfo = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            setPopupData({
                yoyakuKanoTimeInfoList: data.yoyakuKanoTimeInfoList
            });
            onClickOpenPopupWindow("yoyakuTime");
        }
    }

    // 予約時間ポップアップ表示
    const onClickMealTime = () => {
        let reqCourseList = [];
        estheRsvInfo.mainCourseList.forEach((value) => {
            reqCourseList.push({
                courseCd: value.courseCd,
                optionKbn: value.optionKbn,
                hyojunTime: value.hyojunTime
            });
        })
        estheRsvInfo.optionCourseList?.forEach((value) => {
            reqCourseList.push({
                courseCd: value.courseCd,
                optionKbn: value.optionKbn,
                hyojunTime: value.hyojunTime
            });
        })
        let req = {
            honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
            shisetsuCd: estheticInfo.shisetsuCd,
            cornerBunKbn: "2",  /* 固定値 2:エステ */
            rstEstheCd: estheticInfo.estheticCd,
            riyoDate: estheRsvInfo.riyoDate,
            riyoNinzu: 1,
            courseList: reqCourseList,
            importedFlg: true
        }
        common.doPost(getYoyakuKanoTimeInfo, req, afterGetYoyakuKanoTimeInfo);
    }

    // コース一覧取得後処理
    const afterGetCourseInfo = (res, ref) => {
        let data = res.data;
        if (data.resultCode == 0) {
            let courseList = [];
            if (ref.courseType == "mainCourse") {
                courseList = data.courseList.filter(value => value.optionKbn == "1")
            } else if (ref.courseType == "optionCourse") {
                courseList = data.courseList.filter(value => value.optionKbn == "2")
            }
            setPopupData({
                courseList: courseList,
                honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
                shisetsuCd: estheticInfo.shisetsuCd,
                rstEstheCd: estheticInfo.estheticCd,
            });
            onClickOpenPopupWindow(ref.courseType);
        }
    }

    // コースポップアップ表示
    const onClickCourse = (courseType) => {
        // コース情報取得
        let req = {
            honkanShisetsuCd: estheticInfo.honkanShisetsuCd,
            shisetsuCd: estheticInfo.shisetsuCd,
            cornerBunKbn: "2", /* 固定値 */
            rstEstheCd: estheticInfo.estheticCd,
            jikantai: "1",
            riyoDate: estheRsvInfo.riyoDate,
        }
        common.doPostRef(getCourseInfo, req, {courseType}, afterGetCourseInfo);
        setPopupData({
            courseList: []
        });
    }

    // 利用日表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const playDate = new Date(estheRsvInfo.riyoDate);
        const m = playDate.getMonth() + 1;
        const d = playDate.getDate();
        return `${m}月${d}日(${youbi[playDate.getDay()]})`;
    }

    const dispCourse = (course) => {

        // Aコース：〇人, Bコース：〇人, Cコース：〇人, Dコー...
        return course.map(item => {
            return `${item.courseName}`
        }).join(", ");

    }

    const dispRyokin = () => {
        let ryokin = 0;
        if (estheRsvInfo.mainCourseList?.length > 0) {
            let courseList = estheRsvInfo.mainCourseList;
            if (estheRsvInfo.optionCourseList?.length > 0) {
                courseList = courseList.concat(estheRsvInfo.optionCourseList);
            }
            courseList.forEach(course => {
                ryokin += course.tanka;
            })
        }
        return "合計：¥" + ryokin.toLocaleString();
    }

    // 表示用部屋番号を取得
    const getDisplayRoomNo = (value) => {
        try {
            if (value && /^[0-9]+$/.test(value)) {
                // 5桁目以上を削除し、先頭の0を削除
                return value.substring(value.length - 4).replace(/^0+/g, '');
            }
        } catch { }
        return '　';
    };

    const esthe = <div >
        {confirmFlg ?
            <>
                <div className="importedInputWrapper">
                    <div className={"confirmContentsBorder"}>
                        <div className={"inputUserWrap"}>
                            <div className={responsiveFlg ? "confirmContentsBlock" : "confirmContents"}>
                                <Label
                                    label={"料金"}
                                    className="reserveInfoTitleNoWrap"
                                />
                                <div className={"confirmContentsBlock"}>
                                    <Label
                                        label={dispRyokin()}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            :
            <>
                <div className="userInput2">
                    <div className={"stayInfo"} style={styles.userInput}>
                        <ModalOptionForm
                            id={"reserveDate"}
                            divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                            dateClass={flgList.errorRiyoDate ? "errorClass" : ""}
                            title={"利用日"}
                            onClick={openCal}
                            text={estheRsvInfo.riyoDate ? getDateToString() : "選択する"}
                            labelClass={"dateLabel"}
                        />
                        <ModalOptionForm
                            id={"mainCourse"}
                            divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                            labelClassName="popupLabel"
                            dateClass={(estheRsvInfo.riyoDate ? "" : "disabledClass ") + (flgList.errorMainCourse ? "errorClass" : "")}
                            title={"メインメニュー"}
                            onClick={estheRsvInfo.riyoDate ? () => onClickCourse("mainCourse") : null}
                            text={estheRsvInfo.mainCourseList ? estheRsvInfo.mainCourseList.length > 0 ? dispCourse(estheRsvInfo.mainCourseList) : "選択する" : "選択する"}
                        />
                        {/* <ModalOptionForm
                            id={"optionCourse"}
                            divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                            labelClassName="popupLabel"
                            dateClass={(estheRsvInfo?.mainCourseList?.length > 0 ? "" : "disabledClass ") + (flgList.errorOptionCourse ? "errorClass" : "")}
                            title={"オプションメニュー"}
                            onClick={estheRsvInfo?.mainCourseList?.length > 0 ? () => onClickCourse("optionCourse") : null}
                            text={estheRsvInfo.optionCourseList ? estheRsvInfo.optionCourseList.length > 0 ? dispCourse(estheRsvInfo.optionCourseList) : "選択する" : "選択する"}
                        /> */}
                        <ModalOptionForm
                            id={"yoyakuTime"}
                            divClass={responsiveFlg ? "popupWrapLong" : "popupInputUserWrapper"}
                            labelClassName="popupLabel"
                            dateClass={(estheRsvInfo?.mainCourseList?.length > 0 ? "" : "disabledClass ") + (flgList.errorYoyakuTime ? "errorClass" : "")}
                            title={"時間"}
                            onClick={estheRsvInfo.mainCourseList && estheRsvInfo.mainCourseList.length > 0 ? () => onClickMealTime() : null}
                            text={estheRsvInfo.yoyakuTime ? CommonUtil.getTimeStr(estheRsvInfo.yoyakuTime, "hh:mm") : "選択する"}
                        />
                        {agreementList ? agreementList.map((doi, index) =>
                            <div key={"doi" + index} className={'agreementWrapper ' + (flgList.errorDoi?.[index] ? "errorClassCheck" : "")}>
                                <div className='agreementTitleWrapper'>
                                    <a className="confirmContentLink" onClick={() => onClickDoiTitle(index)}>{doi.title}</a>
                                </div>
                                <CheckboxListBoxGold
                                    id={"agreement" + index}
                                    name={"agreement"}
                                    data={[{ ...agreement[0], checked: doi.checked }]}
                                    onChange={() => onChangeAgreement(index)}
                                    tabIndex=""
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </>
        }
    </div>

    const userInfo = <div >
        {confirmFlg ?
            <>
                <div className="reserveInputWrapper lastContent">
                    <div className="userInput2">
                        <div className={"reserveInfo"}>
                            <div className={"inputUserWrap"}>
                                <div className="confirmContentsBorder firstContent">
                                    <Label
                                        label={"利用者"}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                    <div className='confirmContentsBlock'>
                                        <div className="confirmContents">
                                            <Label
                                                label={"氏名（カナ）"}
                                                className="confirmContentLabelGray"
                                            />
                                            <Label
                                                label={estheRsvInfo.daihyouNameKana}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                        <div className="confirmContents">
                                            <Label
                                                label={"氏名（漢字）"}
                                                className="confirmContentLabelGray"
                                            />
                                            <Label
                                                label={estheRsvInfo.daihyouName}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="confirmContentsBorder">
                                    <Label
                                        label={"利用者携帯番号"}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                    <div className='confirmContentsBlock'>
                                        <div className="confirmContents">
                                            <Label
                                                label={estheRsvInfo.mainPhoneNumber}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {loginFlg ?
                                    <>
                                        <div className="confirmContentsBorder">
                                            <Label
                                                label={"予約連絡先電話番号"}
                                                className="reserveInfoTitleNoWrap"
                                            />
                                            <div className='confirmContentsBlock'>
                                                <div className="confirmContents">
                                                    <Label
                                                        label={estheRsvInfo.contactPhoneNumber}
                                                        className="confirmContentLabel"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="confirmContentsBorder">
                                            <Label
                                                label={"予約連絡先メールアドレス"}
                                                className="reserveInfoTitleNoWrap"
                                            />
                                            <div className='confirmContentsBlock'>
                                                <div className="confirmContents">
                                                    <Label
                                                        label={estheRsvInfo.contactMailAddress}
                                                        className="confirmContentLabel"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="confirmContentsBorder">
                                            <Label
                                                label={"会員様とのご関係"}
                                                className="reserveInfoTitleNoWrap"
                                            />
                                            <div className='confirmContentsBlock'>
                                                <div className="confirmContents">
                                                    <Label
                                                        label={estheRsvInfo.relation}
                                                        className="confirmContentLabel"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {estheRsvInfo.relationCd != "" && serviceCheckInfo?.kozafurikaeKanoKbn && serviceCheckInfo.kozafurikaeKanoKbn != "0" ?
                                            <div className="confirmContentsBorder">
                                                <Label
                                                    label={"口座振替精算"}
                                                    className="reserveInfoTitleNoWrap"
                                                />
                                                <div className='confirmContentsBlock'>
                                                    <div className="confirmContents">
                                                        <Label
                                                            label={estheRsvInfo.kozafurikaeFlg && hopeCheckboxData.find(value => value.id == estheRsvInfo.kozafurikaeFlg) ? hopeCheckboxData.find(value => value.id == estheRsvInfo.kozafurikaeFlg).value : "希望しない"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                        }
                                    </>
                                    : null
                                }
                                <div className="confirmContentsBorder">
                                    <Label
                                        label={"備考"}
                                        className="reserveInfoTitleNoWrap"
                                    />
                                    <div className='confirmContentsBlock'>
                                        <div className="confirmContents">
                                            <Label
                                                label={estheRsvInfo.biko ? estheRsvInfo.biko : "　"}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {loginFlg ?
                                    <div className="confirmContentsBorder">
                                        <Label
                                            label={"予約確認メール"}
                                            className="reserveInfoTitleNoWrap"
                                        />
                                        <div className='confirmContentsBlock'>
                                            {responsiveFlg ?
                                                <>
                                                    <div className="confirmContentsBlock">
                                                        <Label
                                                            label={estheRsvInfo.kakuninMailKiboKbn != 0 && estheRsvInfo.kakuninMailKiboKbn && hopeCheckboxData.find(value => value.id == estheRsvInfo.kakuninMailKiboKbn) ? hopeCheckboxData.find(value => value.id == estheRsvInfo.kakuninMailKiboKbn).value : "希望しない"}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                    <div className={estheRsvInfo.kakuninMailKiboKbn != 0 && estheRsvInfo.kakuninMailKiboKbn ? "confirmContentsBlock" : "hiddenItem"}>
                                                        <Label
                                                            label="メールアドレス"
                                                            className="confirmContentLabelGray"
                                                        />
                                                        <Label
                                                            label={estheRsvInfo.confirmReserveMail}
                                                            className="confirmContentLabel"
                                                        />
                                                    </div>
                                                </>
                                                :
                                                <div className="confirmContents">
                                                    <Label
                                                        label={estheRsvInfo.kakuninMailKiboKbn != 0 && estheRsvInfo.kakuninMailKiboKbn && hopeCheckboxData.find(value => value.id == estheRsvInfo.kakuninMailKiboKbn) ? hopeCheckboxData.find(value => value.id == estheRsvInfo.kakuninMailKiboKbn).value : "希望しない"}
                                                        className="confirmContentLabel"
                                                    />
                                                    <Label
                                                        label={estheRsvInfo ? estheRsvInfo.confirmReserveMail : ""}
                                                        className={estheRsvInfo.kakuninMailKiboKbn != 0 && estheRsvInfo.kakuninMailKiboKbn ? "confirmContentLabel" : "hiddenItem"}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    : null}
                                <div className="confirmContentsBorder">
                                    <Label
                                        label={"ご滞在中のお部屋番号"}
                                        className="reserveInfoTitleEstheticNo"
                                    />
                                    <div className='confirmEstheticNo'>
                                        <div className="confirmContents">
                                            <Label
                                                label={estheRsvInfo.estheticNumber ? getDisplayRoomNo(estheRsvInfo.estheticNumber) : "　"}
                                                className="confirmContentLabel"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            :
            <div style={{ padding: "30px 0px" }}>
                <Label
                    label={"利用者"}
                    className="representInfoLabel"
                />
                <LabelInputForm
                    label={"氏名（カナ）"}
                    type={"id"}
                    id="representNameKana"
                    placeholder="ヤマダイチロウ"
                    className={flgList.errorRepresentNameKana ? "inputKeywordError" : "inputKeyword"}
                    value={estheRsvInfo?.representNameKana ? estheRsvInfo.representNameKana : ""}
                    onChange={() => handleRepresentInfo("representNameKana")}
                    labelClassName="popupLabel"
                    wrapClassName="userInputTextWrap3"
                    maxLength={"35"}
                />
                <LabelInputForm
                    label={"氏名（漢字）"}
                    id="representName"
                    placeholder="山田一郎"
                    className={flgList.errorRepresentName ? "inputKeywordError" : "inputKeyword"}
                    value={estheRsvInfo?.representName ? estheRsvInfo.representName : ""}
                    onChange={() => handleRepresentInfo("representName")}
                    labelClassName="popupLabel"
                    wrapClassName="userInputTextWrap3"
                    maxLength={"35"}
                />
                <Label
                    label="利用者携帯番号"
                    className="popupLabel"
                    style={{ marginTop: "20px" }}
                />
                <Label
                    label={messageConst.ESTHETIC_SMS_MESSAGE}
                    className="annotationMessage2"
                />
                <LabelInputForm
                    id="mainPhoneNumber"
                    placeholder="012-345-6789"
                    className={flgList.errorRepresentTelNumber ? "inputKeywordError" : "inputKeyword"}
                    onChange={() => handleRepresentInfo("mainPhoneNumber")}
                    value={estheRsvInfo?.mainPhoneNumber ? estheRsvInfo.mainPhoneNumber : ""}
                    maxLength={"15"}
                />
                {loginFlg ?
                    <>
                        <LabelInputForm
                            label="予約連絡先電話番号"
                            labelClassName="popupLabel"
                            wrapClassName="userInputTextWrap3"
                            id="reserverTelNumber"
                            placeholder="012-345-6789"
                            className={flgList.errorReserverTelNumber ? "inputKeywordError" : "inputKeyword"}
                            onChange={() => handleRepresentInfo("reserverTelNumber")}
                            value={estheRsvInfo ? estheRsvInfo.reserverTelNumber : ""}
                        />
                        <LabelInputForm
                            label={"予約連絡先メールアドレス"}
                            id="reserverMail"
                            placeholder="rtg@trast.jp"
                            className={flgList.errorReserverMail ? "inputKeywordError" : "inputKeyword"}
                            value={isCrawl ? crawlMember.mail_adr : estheRsvInfo ? estheRsvInfo.reserverMail : ""}
                            onChange={() => handleRepresentInfo("reserverMail")}
                            labelClassName="popupLabel"
                            wrapClassName="userInputTextWrap3"
                            disabled={isCrawl}
                            maxLength={"50"}
                        />
                        <Label
                            label="※弊社ドメイン「@resorttrust.co.jp」「@rt-group.jp」からのメールが受信できるよう設定確認をお願いします。"
                            className="annotationMessage"
                        />
                        <PullDownOptionForm
                            title={"会員様とのご関係"}
                            id="relation"
                            divClass="inputUserPullDownWrapLong"
                            labelClassName="popupLabel"
                            selectClass={"pullDownOptionStyle " + (flgList.relation ? "errorClass" : "")}
                            data={relationList}
                            onChange={() => onChangeRelation()}
                            state={estheRsvInfo ? estheRsvInfo.relationCd : ""}
                        />
                        {estheRsvInfo.relationCd != "" && serviceCheckInfo?.kozafurikaeKanoKbn && serviceCheckInfo.kozafurikaeKanoKbn == "1" ?
                            <>
                                <Label
                                    label="口座振替精算"
                                    className="popupLabel"
                                />
                                <div className='checkboxWrapper'>
                                    <CheckboxListBoxGold
                                        id={"kozafurikaeFlg"}
                                        name={"kozafurikaeFlg"}
                                        data={[{ ...hopeCheckboxData[0], checked: estheRsvInfo ? estheRsvInfo.kozafurikaeFlg : false }]}
                                        onChange={() => onChangeCheckBox("kozafurikaeFlg")}
                                        tabIndex=""
                                    />
                                    <a onClick={() => onClickServiceLink("口座振替精算", serviceCheckInfo.kozafurikaeKiyakuMongon)} className="confirmContentLink">口座振替精算とは</a>
                                </div>
                            </>
                            : null
                        }
                    </>
                    : null}
                <div className='userInputTextWrap3'>
                    <Label
                        label="備考"
                        className="popupLabel"
                    />
                    <TextArea
                        id="biko"
                        style={flgList.errorBiko ? styles.bikoError : styles.biko}
                        value={estheRsvInfo?.biko ? estheRsvInfo.biko : ""}
                        onBlur={() => handleRepresentInfo("biko")}
                        maxLength={"666"}
                    />
                </div>
                {loginFlg ?
                    <>
                        <Label
                            label="予約確認メール"
                            className="popupLabel"
                        />
                        <CheckboxListBoxGold
                            id={"kakuninMailKiboKbn"}
                            title={"kakuninMailKiboKbn"}
                            name={"kakuninMailKiboKbn"}
                            data={[{ ...hopeCheckboxData[0], checked: estheRsvInfo && estheRsvInfo.kakuninMailKiboKbn != undefined ? estheRsvInfo.kakuninMailKiboKbn == "1" : true }]}
                            wrapClassName={responsiveFlg ? "popupWrapLong" : "popupWrap"}
                            labelClassName="popupLabel"
                            onChange={() => onChangeCheckBox("kakuninMailKiboKbn")}
                            tabIndex=""
                        />
                        <Label
                            label={messageConst.RESERVE_MAIL_INFO_MESSAGE}
                            className="annotationMessage3"
                        />
                        <CheckboxListBoxGold
                            id={"otherMailFlg"}
                            name={"otherMailFlg"}
                            data={[{ ...otherMailCheckbox[0], checked: estheRsvInfo && estheRsvInfo.otherMailFlg != undefined ? estheRsvInfo.otherMailFlg : false }]}
                            wrapClassName={responsiveFlg ? "popupWrapLong" : "popupWrap"}
                            labelClassName="popupLabel"
                            onChange={() => onChangeCheckBox("otherMailFlg")}
                            tabIndex=""
                        />
                        <LabelInputForm
                            label={"メールアドレス"}
                            id="confirmReserveMail"
                            placeholder="rtg@trast.jp"
                            className={flgList.confirmReserveMail ? "inputKeywordError" : "inputKeyword"}
                            onChange={() => handleRepresentInfo("confirmReserveMail")}
                            labelClassName="popupLabel"
                            wrapClassName="userInputTextWrap2"
                            value={estheRsvInfo.otherMailFlg != undefined && estheRsvInfo.otherMailFlg ? estheRsvInfo.confirmReserveMail : ""}
                            disabled={estheRsvInfo && estheRsvInfo.otherMailFlg != undefined ? !estheRsvInfo.otherMailFlg : true}
                            maxLength={"50"}
                        />
                    </>
                    : null}
                <RoomQrReader
                    label={"ご滞在中のお部屋番号"}
                    id="estheticNumber"
                    labelClassName="estheticNoTitle"
                    wrapClassName="userInputTextWrap3"
                    value={estheRsvInfo?.estheticNumber ? estheRsvInfo.estheticNumber : ""}
                    onRead={() => handleRepresentInfo("estheticNumber")} />
            </div>
        }
    </div>

    return (
        <>
            <div>{esthe}</div>
            <div>{userInfo}</div>
        </>
    );
}

const styles = {
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    biko: {
        resize: "none",
        width: "-webkit-fill-available",
        height: "150px",
        border: "solid 1px #b7b7b7",
    },
    bikoError: {
        resize: "none",
        width: "-webkit-fill-available",
        height: "150px",
        border: "solid 2px #ff0000",
        backgroundColor: "#ffdcdc",
    },
}
const mapStateToProps = (state) => {
    return {
        playDate1: state.playDate1,
    };
};
export default connect(mapStateToProps)(EstheticInputList);